import { apiMipe } from '@/core/api/'
import { SEC_APPLICATION_ID } from '@/config'

export const getUserMenu = async () => {
  try {
    const { data } = await apiMipe.get('/api/account/sitemap?appId=' + SEC_APPLICATION_ID)
    return data
  } catch {
    return []
  }
}

export const getAdditionalProfileInfo = async () => {
  try {
    const { data } = await apiMipe.get('/api/account/getprofileinformation/')
    if (data) {
      const { companies, permissions } = data

      return {
        companies: (companies || []).map(
          ({ id, name, socialSecurityNo, isMainCompany }) => ({
            id,
            name,
            ssn: socialSecurityNo,
            main: isMainCompany,
          })
        ),
        permissions,
      }
    }

    return null
  } catch {
    return null
  }
}
